import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

@Component({
    selector: 'app-upload-failure-popup',
    templateUrl: './upload-failure-popup.component.html',
    styleUrls: ['./upload-failure-popup.component.css'],
    standalone: false
})
export class UploadFailurePopupComponent implements OnInit {
  @Input() failedAtPercentage: number = 0;
  @Input() partialParts: boolean = false;
  @Input() failedParts: boolean = false;
  @Output() closePopup = new EventEmitter<void>();
  @Output() radioSelection = new EventEmitter<any>();
  @Output() fetchPreviousDetails = new EventEmitter<void>(); // Add this line
  config: any;
  uploadAlertMsgFailed = "";
  uploadAlertMsg = "";
  errorMsg: string | undefined;

  constructor() {}
  ngOnInit() {
    if (this.failedParts && !this.partialParts) {
      this.fetchPreviousDetails.emit(); // Emit the event to fetch previous upload details
    }
  }

  onClose() {
    if (!this.radioSelection) {
      this.errorMsg = "No radio option selected. Please choose an option before closing.";
      return;
    }
    this.closePopup.emit(); // Emit the event to notify parent component
  }

  radioHandlerEvent(event: any) {
    this.radioSelection.emit(event);
    this.closePopup.emit(); // Close the popup when a radio button is clicked
  }


}
